import { apiCall } from "./Interceptor";

const GRID_CONECTIVITY_ALL = "/gridConn/getAll/public";

const getAllGridConnectivity = async () => {
    const response = await apiCall.get(GRID_CONECTIVITY_ALL);
    return response;
}

export default {
    getAllGridConnectivity,
};
